import React from 'react';
import { useNavigate } from 'react-router-dom';
import errorImage from '../../assets/images/pages/error.svg';
import './pageNotFound.css';

const PageNotFound = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        console.log("handleGoBack");
        navigate("/"); // Go back to previous page
    };

    return (
        <div className="page-not-found-container">
            <div className="page-not-found-content">
                <div className="text-section">
                    <h1 className="error-title">
                        Page Not Found 🕵🏻‍♂️
                    </h1>
                    <p className="error-message">
                        Oops! 😖 The requested URL was not found on this server.
                    </p>
                    <button
                        className="back-button"
                        onClick={handleGoBack}
                    >
                        Go to Login Page
                    </button>
                </div>
                <div className="image-section">
                    <img
                        src={errorImage}
                        alt="Page not found illustration"
                        className="error-illustration"
                    />
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
